// src/store/shop/shopActions.js

import {
    ADD_PRODUCTS,
    ADD_POPULAR_PRODUCTS,
    ADD_FILTERS,
  } from './shopActionsTypes';
  import axios from 'axios';
  
  export function addProducts(products) {
    return { type: ADD_PRODUCTS, payload: products };
  }
  
  export function addPopularProducts(products) {
    return { type: ADD_POPULAR_PRODUCTS, payload: products };
  }
  
  export function addFilters(category) {
    return { type: ADD_FILTERS, payload: category };
  }
  
function extractList(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    return Array.isArray(data.product_list) ? data.product_list : [];
  }
  
  export function getPopularProducts(categoryId) {
    return dispatch => {
      return axios
        // если бек теперь ждёт параметр ?category=, а не ?category_id=
        .get(`https://catalog.tstmetal.site/products?category_id=${categoryId}`)
        .then(res => {
          const data = res.data;
          const list = Array.isArray(data)
            ? data
            : data.product_list || [];
          dispatch(addPopularProducts(list));
        })
        .catch(err => console.error(err));
    };
  }
  
  export function chandgeCategory(categoryId) {
    return dispatch => {
      // 1) список товаров
      axios
        .get(`https://catalog.tstmetal.site/products?category_id=${categoryId}`)
        .then(res => {
          const raw = res.data || [];
          const list = Array.isArray(raw)
            ? raw
            : raw.product_list || [];
          dispatch(addProducts(list));
        })
        .catch(err => console.error(err));
  
      // 2) данные по категории (для фильтров)
      axios
        .get(`https://catalog.tstmetal.site/categories/${categoryId}`, { responseType: 'json' })
        .then(res => {
          let cat = res.data;
          if (cat.category_list && Array.isArray(cat.category_list)) {
            cat = cat.category_list[0];
          }
          if (Array.isArray(cat)) {
            cat = cat[0];
          }
         dispatch(addFilters(cat));
        })
        .catch(err => console.error(err));
    };
  }
  